import React, { useEffect, useRef, useState } from "react";
import CheckPicker from "rsuite/esm/CheckPicker";
import Checkbox from "rsuite/esm/Checkbox";
import { apiRequest, isValidJSON } from "../../../../utils/utils";
import Button from "rsuite/Button";
import { getCookie } from "../../../common/Utility";
import SelectPicker from "rsuite/esm/SelectPicker";
import "rsuite/dist/rsuite.min.css";
import Modal from "rsuite/esm/Modal";
import { VscTriangleDown } from "react-icons/vsc";
import AdvanceFilterComponent from "./AdvanceFilterComponent";
import Whisper from "rsuite/esm/Whisper";
import Tooltip from "rsuite/esm/Tooltip";
import TrashIcon from "@rsuite/icons/Trash";
import EditIcon from "@rsuite/icons/Edit";
import { FaRegCopy } from "react-icons/fa";
import { IoShareSocial } from "react-icons/io5";
import Popover from "rsuite/Popover";
import Input from "rsuite/Input";
import InputGroup from "rsuite/InputGroup";

const LeadsListingTopFilter = ({
  filters,
  onFilterChange,
  syncFilterWithAggrid,
  resetFilters,
  search,
  setSearch,
  setColumnsValueSearch,
  advanceFilter,
  setAdvanceFilter,
  editFilter,
  setEditFilter,
  selectedFilter,
  setSelectedFilter,
  filterList,
  fetchFilters,
  deleteConfirm,
  setDeleteConfirm,
  isPublic,
  setIsPublic,
  attribute_set_key,
  // setAttribute_set_key,
  advfilters,
  setFilters,
  aggridData,
  columnsDef,
  sharedFilterId,
  quickFilters,
  selectedContactFilter,
  setSelectedContactFilter,
}) => {
  let user_uuid =
    getCookie("muvi_useruuid") || "45cfe77780ec435cb7ba63618e013baa";
  const [openPicker, setOpenPicker] = useState(null);
  const [loading, setLoading] = useState({});
  const [filterName, setFilterName] = useState("");
  const [shareUrl, setShareUrl] = useState(null);
  const [generatingLink, setGeneratingLink] = useState(false);
  const [copyFeedback, setCopyFeedback] = useState(false);

  useEffect(() => {
    setSelectedFilter(filterList.find((f) => f.value === editFilter) || null);
  }, [editFilter]);

  useEffect(() => {
    if (!attribute_set_key) return;
    fetchFilters();
  }, [attribute_set_key]);

  const handleChange = (value, type = "") => {
    if (type === "contact") {
      setSelectedContactFilter(value || null);
    } else {
      const found = filterList.find((f) => f.value === value);
      setSelectedFilter(found || null);
    }
  };

  const searchRef = useRef(null);

  const handleDelete = async () => {
    const payload = {
      filter_id: deleteConfirm,
    };

    try {
      const res = await fetch(
        `${process.env.REACT_APP_tattle_api}/delete-custom-filter`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const data = await res.json();
      if (data.code || data.code == 200) {
        setSelectedFilter(null);
        fetchFilters();
      }
    } catch (err) {
      console.error("API Error:", err);
    }
  };

  const isReady = useRef(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      isReady.current = true;
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (!isReady.current) return; // Do nothing for first 2 seconds after load

    setShareUrl(null);
  }, [aggridData.syncFilterWithAggrid]);

  useEffect(() => {
    //get data from local storage
    let localdata = localStorage.getItem("crm_leads");
    if (localdata && isValidJSON(localdata)) {
      localdata = JSON.parse(localdata);
      syncFilterWithAggrid(localdata);
    }
  }, []);

  useEffect(() => {
    if (searchRef.current) clearTimeout(searchRef.current);

    searchRef.current = setTimeout(() => {
      onFilterChange(search, "search");
    }, 500);
  }, [search]);

  const resetHandler = () => {
    resetFilters();
    setSelectedFilter(null);
    setSelectedContactFilter(null);
    // clearLocalStorage("crm_leads");
    // localStorage.setItem("crm_leads", JSON.stringify({}));
    setSearch("");
    setColumnsValueSearch({ key: "", value: "" });
    setFilters([{ field: "", condition: "eq", value: "" }]);
    // setAttribute_set_key("contacts");
  };

  const handleCopy = (url = "") => {
    navigator.clipboard.writeText(shareUrl ? shareUrl : url);
    setCopyFeedback(true);
    setTimeout(() => {
      setCopyFeedback(false);
    }, 1500);
  };

  useEffect(() => {
    if (sharedFilterId) {
      const url = `${window.location.origin}/${attribute_set_key}/list/share/${sharedFilterId}`;

      setShareUrl(url);
    }
  }, [sharedFilterId]);

  function hasActiveFilters(sync) {
    if (!sync || Object.keys(sync).length === 0) return false;

    // Check each filter category values
    return Object.values(sync).some(function (value) {
      // Case 1: null, undefined, empty array → no filter
      if (!value || (Array.isArray(value) && value.length === 0)) return false;

      // Case 2: value is an empty object {}
      if (
        typeof value === "object" &&
        !Array.isArray(value) &&
        Object.keys(value).length === 0
      )
        return false;

      return true; // At least one active filter exists
    });
  }
  const hasFilters = hasActiveFilters(
    aggridData && aggridData.syncFilterWithAggrid,
  );

  const generateShareLink = async () => {
    // If already generated, do nothing (Popover will show the link)
    if (shareUrl) {
      return;
    }

    setGeneratingLink(true);

    const payload = {
      app_token: aggridData.app_token,
      attribute_set_key,
      user_uuid: user_uuid || "45cfe77780ec435cb7ba63618e013baa",
      filter_name: "Shareble Filter",
      filter_value: aggridData.syncFilterWithAggrid,
      is_system: 0,
      filter_type: 3,
    };

    try {
      const apiEndpoint = `${process.env.REACT_APP_tattle_api}/create-custom-filter`;

      const response = await fetch(apiEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.code !== 200) {
        throw new Error(data.message || "Failed to save filter");
      }

      const filter_id = data.data.filter_id;
      const url = `${window.location.origin}/${attribute_set_key}/list/share/${filter_id}`;

      setShareUrl(url);
    } catch (err) {
      console.error("Save filter failed:", err);
    } finally {
      setGeneratingLink(false);
    }
  };

  return (
    <React.Fragment>
      {quickFilters && Object.entries(quickFilters).length > 0 && (
        <div
          className="d-flex mt-5"
          style={{ justifyContent: "space-between" }}
        >
          <div
            class="d-flex quick-filter-list"
            style={{ margin: "1rem .5rem", gap: "7px" }}
          >
            {quickFilters &&
              Object.entries(quickFilters).map(([key, config]) => {
                // config is an array → extract actual config
                const item = config && config[0];
                if (!item) return null;

                // Skip custom & system filters
                if (key === "custom" || key === "system") return null;

                if (
                  item.attribute_type === "select" ||
                  item.attribute_type === "api"
                ) {
                  const isMulti = item.multiple === 1; // <--- NEW
                  const hasValues =
                    filters && filters[key] && filters[key].length;
                  const options = Array.isArray(item.options)
                    ? item.options
                    : [];
                  const value = filters && filters[key] ? filters[key] : [];
                  const isLoading = loading && loading[key];

                  // Multi-select → CheckPicker
                  if (isMulti) {
                    const handleSelectAll = (checked) => {
                      if (checked) {
                        const allValues = options.map((o) => o.value);
                        onFilterChange(allValues, key);
                      } else {
                        onFilterChange([], key);
                      }
                    };

                    const currentValues =
                      filters && filters[key] ? filters[key] : [];
                    const isAllSelected =
                      options.length > 0 &&
                      currentValues.length === options.length;
                    const isIndeterminate =
                      currentValues.length > 0 &&
                      currentValues.length < options.length;

                    return (
                      <div className="filter-single" key={key}>
                        <div className="input-box">
                          <CheckPicker
                            className={`filter-subtle ${
                              hasValues ? "selected-gray" : ""
                            }`}
                            virtualized
                            searchBy="label"
                            appearance="subtle"
                            caretAs={VscTriangleDown}
                            data={options}
                            value={value}
                            onChange={(val) => onFilterChange(val, key)}
                            style={{ width: "100%", zIndex: 1050 }}
                            menuClassName={`filter-picker ${
                              openPicker === key
                                ? "dropdown-open"
                                : "dropdown-close"
                            }`}
                            onOpen={() => setOpenPicker(key)}
                            onClose={() => setOpenPicker(null)}
                            block
                            placeholder={item.name}
                            loading={isLoading}
                            renderMenu={(menu) => (
                              <div>
                                <div
                                  style={{
                                    padding: "0px 4px",
                                    display: "flex",
                                    alignItems: "center",
                                    backgroundColor: "#d3ecf640",
                                  }}
                                >
                                  <Checkbox
                                    checked={isAllSelected}
                                    indeterminate={isIndeterminate}
                                    onChange={(v, checked) =>
                                      handleSelectAll(checked)
                                    }
                                  >
                                    Select All
                                  </Checkbox>
                                </div>
                                <hr style={{ margin: 0 }} />
                                {menu}
                              </div>
                            )}
                          />
                        </div>
                      </div>
                    );
                  }

                  // Single-select → SelectPicker
                  return (
                    <div className="filter-single" key={key}>
                      <div className="input-box">
                        <SelectPicker
                          className={`filter-subtle ${
                            hasValues ? "selected-gray" : ""
                          }`}
                          appearance="subtle"
                          caretAs={VscTriangleDown}
                          data={options}
                          value={value[0] || null}
                          onChange={(val) => onFilterChange([val], key)} // store as array
                          style={{ width: "100%", zIndex: 1050 }}
                          menuClassName={`filter-picker ${
                            openPicker === key
                              ? "dropdown-open"
                              : "dropdown-close"
                          }`}
                          onOpen={() => setOpenPicker(key)}
                          onClose={() => setOpenPicker(null)}
                          placeholder={item.name}
                          loading={isLoading}
                        />
                      </div>
                    </div>
                  );
                } else if (item.attribute_type === "adv_filter") {
                  const hasSelected = selectedContactFilter ? true : false;
                  const isContactOpen = openPicker === "contactfilter";
                  const advOptions =
                    item && item.options && Array.isArray(item.options)
                      ? item.options
                      : [];

                  return (
                    <div className="filter-single" key={key}>
                      <div className="input-box">
                        <SelectPicker
                          className={`filter-subtle ${
                            hasSelected ? "selected-gray" : ""
                          }`}
                          data={advOptions}
                          appearance="subtle"
                          caretAs={VscTriangleDown}
                          placeholder={item.name || ""}
                          value={hasSelected ? selectedContactFilter : null}
                          onChange={(val) => handleChange(val, "contact")}
                          style={{ width: "100%" }}
                          searchable={true}
                          menuClassName={`filter-picker ${
                            isContactOpen ? "dropdown-open" : "dropdown-close"
                          }`}
                          onOpen={() => setOpenPicker("contactfilter")}
                          onClose={() => setOpenPicker(null)}
                        />
                      </div>
                    </div>
                  );
                }

                return null;
              })}

            {/* My Filters */}
            {quickFilters && (quickFilters.custom || quickFilters.system) && (
              <div className="filter-single">
                <div class="input-box">
                  <SelectPicker
                    className={`filter-subtle ${selectedFilter && selectedFilter.value
                        ? "selected-gray"
                        : ""
                      }`}
                    data={filterList}
                    appearance="subtle"
                    caretAs={VscTriangleDown}
                    placeholder="My Filters"
                    value={selectedFilter ? selectedFilter.value : null}
                    onChange={handleChange}
                    style={{ width: "100%" }}
                    searchable={true}
                    menuClassName={`filter-picker ${
                      openPicker === "advfilter"
                        ? "dropdown-open"
                        : "dropdown-close"
                    }`}
                    onOpen={() => setOpenPicker("advfilter")}
                    onClose={() => setOpenPicker(null)}
                    renderMenuItem={(label, item) => {
                      if (item.type === "separator") {
                        return (
                          <div
                            style={{
                              borderBottom: "1px solid #eee",
                              margin: "4px 0",
                            }}
                          />
                        );
                      }

                      return (
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span>{label}</span>

                          {/* Show icons for Custom filters OR System filters with canEdit:true */}
                          {(item.group === "Custom Filters" ||
                            item.canEdit) && (
                            <div style={{ display: "flex", gap: "8px" }}>
                              {/* Edit Icon */}
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={<Tooltip>Edit</Tooltip>}
                              >
                                <span
                                  style={{ cursor: "pointer", padding: "3px" }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setEditFilter(item.value);
                                    setAdvanceFilter(true);
                                    setIsPublic(
                                      item.group !== "Custom Filters" || false
                                    );
                                  }}
                                >
                                  <EditIcon style={{ fontSize: 16 }} />
                                </span>
                              </Whisper>

                              {/* Delete Icon */}
                              <Whisper
                                placement="top"
                                trigger="hover"
                                speaker={<Tooltip>Delete</Tooltip>}
                              >
                                <span
                                  style={{
                                    cursor: "pointer",
                                    padding: "3px",
                                    color: "red",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    setDeleteConfirm(item.value);
                                  }}
                                >
                                  <TrashIcon style={{ fontSize: 16 }} />
                                </span>
                              </Whisper>
                            </div>
                          )}
                        </div>
                      );
                    }}
                  />
                </div>
              </div>
            )}
            <div className="separator advf"></div>
            <div className="filter-single border-left adv-filter-box">
              <AdvanceFilterComponent
                advanceFilter={advanceFilter}
                columnsDef={columnsDef}
                setAdvanceFilter={setAdvanceFilter}
                onFilterChange={onFilterChange}
                selectedFilter={selectedFilter}
                setSelectedFilter={setSelectedFilter}
                editFilter={editFilter}
                setEditFilter={setEditFilter}
                fetchFilters={fetchFilters}
                isPublic={isPublic}
                setIsPublic={setIsPublic}
                
                filters={advfilters}
                setFilters={setFilters}
                attribute_set_key={attribute_set_key}
                filterName={filterName}
                setFilterName={setFilterName}
              />
            </div>
          </div>
          {/* </div> */}
          {/* <div className="col-md-2"> */}
          <div
            className="d-flex justify-content-end align-items-center"
            style={{
              marginTop: "10px",
              marginRight: "1rem",
              marginBottom: "10px",
            }}
          >
            {/* Share Button */}
            <Whisper
              placement="bottomEnd"
              trigger="click"
              className="shar-tooltip"
              speaker={
                <Popover full style={{ boxShadow: "var(--rs-shadow-overlay)" }}>
                  <div style={{ width: 300, padding: 10 }}>
                    {generatingLink ? (
                      <div className="text-center">Generating Link...</div>
                    ) : (
                      <InputGroup className="shareable" inside>
                        <Input
                          value={shareUrl || ""}
                          readOnly
                          style={{
                            boxShadow: "none",
                            border: "1px solid #e5e5ea",
                            borderRadius: "0px",
                          }}
                          onClick={(e) => e.target.select()}
                        />
                        <InputGroup.Button onClick={() => handleCopy()}>
                          {copyFeedback ? (
                            <span
                              style={{
                                color: "green",
                                fontSize: "12px",
                                animation: "fadeIn 0.5s",
                              }}
                            >
                              Copied
                            </span>
                          ) : (
                            <FaRegCopy />
                          )}
                        </InputGroup.Button>
                      </InputGroup>
                    )}
                  </div>
                </Popover>
              }
            >
              <button
                className="toogle-btn"
                onClick={() => {
                  if (hasFilters) {
                    generateShareLink();
                  }
                }}
                disabled={!hasFilters}
                style={{
                  height: "37px",
                  border: "none",
                  cursor: hasFilters ? "pointer" : "not-allowed",
                  opacity: hasFilters ? 1 : 0.6,
                }}
              >
                <span>
                  <IoShareSocial />
                </span>
              </button>
            </Whisper>

            {/* Reset Button */}
            <Whisper
              placement="bottom"
              trigger="hover"
              speaker={<Tooltip>Reset</Tooltip>}
            >
              <div
                class="toogle-btn"
                onClick={resetHandler}
                style={{ height: "37px", border: "none" }}
              >
                <span>
                  <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M0.666748 2.66666V6.66666H4.66675"
                      stroke="#202223"
                      stroke-opacity="0.5"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                    <path
                      d="M2.34008 10C2.77234 11.2269 3.59164 12.2801 4.67452 13.0009C5.7574 13.7217 7.0452 14.0711 8.34389 13.9963C9.64258 13.9216 10.8818 13.4268 11.8748 12.5865C12.8679 11.7462 13.5609 10.606 13.8496 9.33758C14.1382 8.06917 14.0068 6.74131 13.4752 5.55407C12.9435 4.36684 12.0404 3.38454 10.902 2.75518C9.76351 2.12583 8.45135 1.88352 7.1632 2.06475C5.87505 2.24599 4.68069 2.84095 3.76008 3.76001L0.666748 6.66667"
                      stroke="#202223"
                      stroke-opacity="0.5"
                      stroke-width="1.33"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    ></path>
                  </svg>
                </span>
              </div>
            </Whisper>
          </div>
          {/* </div> */}
        </div>
      )}

      <Modal open={deleteConfirm} onClose={() => setDeleteConfirm(null)}>
        <Modal.Header>
          <Modal.Title>Delete Filter</Modal.Title>
        </Modal.Header>

        <Modal.Body>Are you sure you want to delete this filter?</Modal.Body>

        <Modal.Footer>
          <Button
            appearance="primary"
            onClick={() => handleDelete(deleteConfirm)}
          >
            Delete
          </Button>

          <Button appearance="subtle" onClick={() => setDeleteConfirm(null)}>
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

export default LeadsListingTopFilter;



// WEBPACK FOOTER //
// ./src/components/crm/leads/components/LeadsListingTopFilter.js